import { useTranslation } from '@mint-lib/i18n';
import { SearchBar } from '@mint-lib/tw-components/patterns';

export type LabelsSearchProps = {
  searchValue: string;
  setSearchValue: (value: string) => void;
};

export const LabelsSearch = ({
  searchValue,
  setSearchValue,
}: LabelsSearchProps) => {
  const { t } = useTranslation('@mint-lib/labels-table');
  return (
    <SearchBar
      value={searchValue}
      onChange={(e) => setSearchValue(e.target.value)}
      placeholder={t('Search labels')}
      onClear={() => setSearchValue('')}
      size="small"
    />
  );
};
